export interface TowerArtSpec {
  /** Separate cutout for the stationary chassis, authored to sit on the pad. */
  bodyKey: string;
  /** Complete rotating turret head, mounted above the stationary chassis. */
  weaponKey: string;
  bodyOrigin: { x: number; y: number };
  weaponOrigin: { x: number; y: number };
  bodyTarget: number;
  weaponTarget: number;
  /** Drops the complete tower assembly onto the pad's mounting plane. */
  mountOffset: number;
  /** Screen-space lift that places the rotating weapon above the chassis. */
  weaponLift: number;
  /** Screen rotation that maps the authored turret barrel onto world aim. */
  weaponRotationOffset: number;
}

/** Runtime composition metadata for the perspective-correct tower set. */
export const TOWER_ART: Record<string, TowerArtSpec> = {
  energy: {
    bodyKey: 'tower-energy-body-v1',
    weaponKey: 'top-energy-v3',
    bodyOrigin: { x: 0.5, y: 0.88 },
    weaponOrigin: { x: 0.5, y: 0.5 },
    bodyTarget: 57.6,
    weaponTarget: 48,
    mountOffset: 6,
    weaponLift: 28,
    weaponRotationOffset: Math.PI * 0.5,
  },
};
